import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from "react";
import favicon from "../assets/icons/favicon.ico";
import favicon16 from "../assets/icons/favicon-16x16.png";
import favicon32 from "../assets/icons/favicon-32x32.png";
import appleIcon from "../assets/icons/apple-touch-icon.png";
import appleIcon57 from "../assets/icons/apple-touch-icon-57x57.png";
import appleIcon60 from "../assets/icons/apple-touch-icon-60x60.png";
import appleIcon72 from "../assets/icons/apple-touch-icon-72x72.png";
import appleIcon76 from "../assets/icons/apple-touch-icon-76x76.png";
import appleIcon114 from "../assets/icons/apple-touch-icon-114x114.png";
import appleIcon120 from "../assets/icons/apple-touch-icon-120x120.png";
import appleIcon144 from "../assets/icons/apple-touch-icon-144x144.png";
import appleIcon152 from "../assets/icons/apple-touch-icon-152x152.png";
import appleIcon180 from "../assets/icons/apple-touch-icon-180x180.png";
import androidIcon192 from "../assets/icons/android-chrome-192x192.png";
import androidIcon512 from "../assets/icons/android-chrome-512x512.png";
import msIcon150 from "../assets/icons/mstile-150x150.png";
var seo = {
    copyright: "lululemon athletica",
    msvalidate: "BC99781198FFC36C9B0934B4595588F9",
    pinterestSiteVerification: "a83af544e6984328ac673cf32812cd29",
    googleSiteVerification1: "CWhKzitkFA-kJcNqPadn_qflTBVY7014hhqJoejDKlM",
    googleSiteVerification2: "ujmdbvtDit40Bd3SvZy-mb8r-yNoJVdg4tssZmuABmk",
    googleSiteVerification3: "_svf35AgLvsczRzQXs49hOCxti9yGvj_mjI8-DEuTbU",
    googleSiteVerification4: "LLo9ferOZhYAxo1bTg3RsbD30PjdPKxhDE2_ycpZpJ8",
    googleSiteVerification5: "5qhjQXTAN9kHVrT5SyvYku7PZsdOxvZNYhsMrDQVvMA",
    googleSiteVerification6: "TLf9WuyLNN3U-MaFuFZGHJua5tCoRgh1ChwuFBZC1Iw",
    googleSiteVerification7: "KdT1gnZtd1Nx-z9LXcVghhHCMdhoul_LGEAgJeziviQ",
    appleItunes: "app-id=920098546",
    googlePlay: "app-id=com.lululemon.shop"
};
var localPrefix = "production" === "development" ? "https://globalstaticassets.lululemon.com" : "";
// TODO: Google Lighthouse audit rule "Ensure text remains visible during webfont load"
// TODO: https://web.dev/font-display/?utm_source=lighthouse&utm_medium=devtools allow text user-visible while webfonts are loading saving 790-930ms of performance
export var fonts = "\n@font-face {\n  font-family: 'utility-icons';\n  font-style: normal;\n  font-weight: normal;\n  src: url('".concat(localPrefix, "/fonts/utility-icons/utility-icons.eot?#iefix') format('embedded-opentype'),\n    url('").concat(localPrefix, "/fonts/utility-icons/utility-icons.woff') format('woff'),\n    url('").concat(localPrefix, "/fonts/utility-icons/utility-icons.ttf') format('truetype'),\n    url('").concat(localPrefix, "/fonts/utility-icons/utility-icons.svg#utility-icons') format('svg');\n    font-display: swap;\n}\n\n@font-face {\n  font-family: 'Calibre';\n  font-style: normal;\n  font-weight: 100;\n  src: url('").concat(localPrefix, "/fonts/CalibreWeb-Thin.eot?#iefix') format('embedded-opentype'),\n    url('").concat(localPrefix, "/fonts/Calibreweb-Thin.woff2') format('woff2');\n    font-display: swap;\n}\n\n@font-face {\n  font-family: 'Calibre';\n  font-style: normal;\n  font-weight: 300;\n  src: url('").concat(localPrefix, "/fonts/CalibreWeb-Light.eot?#iefix') format('embedded-opentype'),\n    url('").concat(localPrefix, "/fonts/Calibreweb-Light.woff2') format('woff2');\n    font-display: swap;\n}\n\n@font-face {\n  font-family: 'Calibre';\n  font-style: normal;\n  font-weight: 400;\n  src: url('").concat(localPrefix, "/fonts/CalibreWeb-Regular.eot?#iefix') format('embedded-opentype'),\n    url('").concat(localPrefix, "/fonts/Calibreweb-Regular.woff2') format('woff2');\n    font-display: swap;\n}\n\n@font-face {\n  font-family: 'Calibre';\n  font-style: normal;\n  font-weight: 500;\n  src: url('").concat(localPrefix, "/fonts/CalibreWeb-Medium.eot?#iefix') format('embedded-opentype'),\n    url('").concat(localPrefix, "/fonts/Calibreweb-Medium.woff2') format('woff2');\n    font-display: swap;\n}\n\n@font-face {\n  font-family: 'Calibre';\n  font-style: normal;\n  font-weight: 600;\n  src: url('").concat(localPrefix, "/fonts/CalibreWeb-Semibold.eot?#iefix') format('embedded-opentype'),\n    url('").concat(localPrefix, "/fonts/Calibreweb-Semibold.woff2') format('woff2');\n    font-display: swap;\n}\nhtml {\n  font-family: 'Calibre', 'Helvetica Neue', 'Helvetica', 'Roboto', 'Arial', sans-serif;\n}\n");
var HeadLinks = function() {
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("link", {
                rel: "shortcut icon",
                href: "".concat(favicon.src || favicon)
            }),
            /*#__PURE__*/ _jsx("link", {
                rel: "icon",
                type: "image/png",
                href: "".concat(favicon16.src || favicon16),
                sizes: "16x16"
            }),
            /*#__PURE__*/ _jsx("link", {
                rel: "icon",
                type: "image/png",
                href: "".concat(favicon32.src || favicon32),
                sizes: "32x32"
            }),
            /*#__PURE__*/ _jsx("link", {
                rel: "apple-touch-icon",
                href: "".concat(appleIcon.src || appleIcon),
                sizes: "180x180"
            }),
            /*#__PURE__*/ _jsx("link", {
                rel: "apple-touch-icon",
                type: "image/png",
                href: "".concat(appleIcon57.src || appleIcon57),
                sizes: "57x57"
            }),
            /*#__PURE__*/ _jsx("link", {
                rel: "apple-touch-icon",
                type: "image/png",
                href: "".concat(appleIcon60.src || appleIcon60),
                sizes: "60x60"
            }),
            /*#__PURE__*/ _jsx("link", {
                rel: "apple-touch-icon",
                type: "image/png",
                href: "".concat(appleIcon72.src || appleIcon72),
                sizes: "72x72"
            }),
            /*#__PURE__*/ _jsx("link", {
                rel: "apple-touch-icon",
                type: "image/png",
                href: "".concat(appleIcon76.src || appleIcon76),
                sizes: "76x76"
            }),
            /*#__PURE__*/ _jsx("link", {
                rel: "apple-touch-icon",
                type: "image/png",
                href: "".concat(appleIcon114.src || appleIcon114),
                sizes: "114x114"
            }),
            /*#__PURE__*/ _jsx("link", {
                rel: "apple-touch-icon",
                type: "image/png",
                href: "".concat(appleIcon120.src || appleIcon120),
                sizes: "120x120"
            }),
            /*#__PURE__*/ _jsx("link", {
                rel: "apple-touch-icon",
                type: "image/png",
                href: "".concat(appleIcon144.src || appleIcon144),
                sizes: "144x144"
            }),
            /*#__PURE__*/ _jsx("link", {
                rel: "apple-touch-icon",
                type: "image/png",
                href: "".concat(appleIcon152.src || appleIcon152),
                sizes: "152x152"
            }),
            /*#__PURE__*/ _jsx("link", {
                rel: "apple-touch-icon",
                type: "image/png",
                href: "".concat(appleIcon180.src || appleIcon180),
                sizes: "180x180"
            }),
            /*#__PURE__*/ _jsx("link", {
                rel: "icon",
                type: "image/png",
                href: "".concat(androidIcon192.src || androidIcon192),
                sizes: "192x192"
            }),
            /*#__PURE__*/ _jsx("link", {
                rel: "icon",
                type: "image/png",
                href: "".concat(androidIcon512.src || androidIcon512),
                sizes: "512x512"
            })
        ]
    });
};
// exporting these tags separately as they should come before the <title /> tag
// based on ranking from https://rviscomi.github.io/capo.js/user/rules for CE2-3823
export function PriorityMetaTags() {
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("meta", {
                httpEquiv: "X-UA-Compatible",
                content: "IE=EmulateIE9"
            }),
            /*#__PURE__*/ _jsx("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1.0, maximum-scale=2, user-scalable=yes, minimal-ui"
            }, "viewport")
        ]
    });
}
function PreloadFonts() {
    return [
        "Thin",
        "Light",
        "Regular",
        "Medium",
        "Semibold"
    ].map(function(fontWeight) {
        return /*#__PURE__*/ _jsx("link", {
            rel: "preload",
            href: "/fonts/Calibreweb-".concat(fontWeight, ".woff2"),
            as: "font",
            type: "font/woff2",
            crossOrigin: "anonymous"
        }, "Calibre-".concat(fontWeight));
    });
}
export default function StaticHead() {
    return /*#__PURE__*/ _jsxs(React.Fragment, {
        children: [
            /*#__PURE__*/ _jsx("meta", {
                name: "apple-mobile-web-app-capable",
                content: "yes"
            }),
            /*#__PURE__*/ _jsx("meta", {
                name: "apple-mobile-web-app-status-bar-style",
                content: "black-translucent"
            }),
            /*#__PURE__*/ _jsx("meta", {
                name: "apple-mobile-web-app-title",
                content: "lululemon"
            }),
            /*#__PURE__*/ _jsx("meta", {
                name: "msapplication-TileImage",
                content: "".concat(msIcon150.src || msIcon150)
            }),
            /*#__PURE__*/ _jsx("meta", {
                name: "application-name",
                content: "lululemon"
            }),
            /*#__PURE__*/ _jsx("meta", {
                name: "format-detection",
                content: "telephone=no"
            }),
            /*#__PURE__*/ _jsx("meta", {
                name: "copyright",
                content: seo.copyright
            }),
            /*#__PURE__*/ _jsx("meta", {
                name: "msvalidate.01",
                content: seo.msvalidate
            }),
            /*#__PURE__*/ _jsx("meta", {
                name: "p:domain_verify",
                content: seo.pinterestSiteVerification
            }),
            /*#__PURE__*/ _jsx("meta", {
                name: "google-site-verification",
                content: seo.googleSiteVerification1
            }, 1),
            /*#__PURE__*/ _jsx("meta", {
                name: "google-site-verification",
                content: seo.googleSiteVerification2
            }, 2),
            /*#__PURE__*/ _jsx("meta", {
                name: "google-site-verification",
                content: seo.googleSiteVerification3
            }, 3),
            /*#__PURE__*/ _jsx("meta", {
                name: "google-site-verification",
                content: seo.googleSiteVerification4
            }, 4),
            /*#__PURE__*/ _jsx("meta", {
                name: "google-site-verification",
                content: seo.googleSiteVerification5
            }, 5),
            /*#__PURE__*/ _jsx("meta", {
                name: "google-site-verification",
                content: seo.googleSiteVerification6
            }, 6),
            /*#__PURE__*/ _jsx("meta", {
                name: "google-site-verification",
                content: seo.googleSiteVerification7
            }, 7),
            /*#__PURE__*/ _jsx("meta", {
                name: "apple-itunes-app",
                content: seo.appleItunes
            }),
            /*#__PURE__*/ _jsx("meta", {
                name: "google-play-app",
                content: seo.googlePlay
            }),
            "production" === "production" && /*#__PURE__*/ _jsx(PreloadFonts, {}),
            /*#__PURE__*/ _jsx(HeadLinks, {})
        ]
    });
};
